<app-scroll-view class="scroll-view">
  <section class="section-inputs">
    <div class="field-set">
      <label label>
        {{
          translationService.getCurrentLanguage()["coordinates-list"] ||
            "Lista de coordenadas"
        }}

        <div class="help-hint" #helpHintEl>
          <app-iconic
            class="icon"
            icon="assets/icons/circle-question.svg"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-iconic>

          <app-tooltip
            [target]="helpHintEl"
            verticalAlignment="top"
            horizontalAlignment="center"
          >
            <span [innerHtml]="helpHintTooltip"></span>
          </app-tooltip>
        </div>
      </label>

      <app-text-area
        [(value)]="inCoordsListText"
        resize="none"
        [rows]="5"
        [showErrorEnabled]="false"
        [showClearButton]="false"
        [placeholder]="hintText"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-text-area>
    </div>

    <div class="controls">
      <app-select-box
        class="select-system-coords"
        [(value)]="wkidInSelected"
        [items]="wkidInItemList"
        displayExpr="label"
        valueExpr="value"
        [showErrorEnabled]="false"
        [showClearButton]="false"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
      </app-select-box>

      <div
        class="btn-item"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        <app-button
          buttonType="primary"
          styleType="contained"
          sizeType="small"
          [text]="
            translationService.getCurrentLanguage()['display'] || 'Representar'
          "
          (click)="onBtnPutIntoMapClick()"
          [disabled]="!wkidInSelected"
          width="12.1rem"
        ></app-button>
      </div>
    </div>
  </section>

  <section class="section-outputs">
    <div class="field-set">
      <label label>
        {{
          translationService.getCurrentLanguage()[
            "projected-coordinates-list"
          ] || "Lista de coordenadas Projetadas"
        }}</label
      >

      <app-text-area
        [(value)]="outCoordsListText"
        resize="none"
        [rows]="5"
        [showErrorEnabled]="false"
        [showClearButton]="false"
        [readOnly]="true"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-text-area>
    </div>

    <div class="controls">
      <app-select-box
        class="select-system-coords"
        [(value)]="wkidItemOutSelected"
        [items]="wkidOutItemList"
        displayExpr="label"
        [showErrorEnabled]="false"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
      </app-select-box>

      <div
        class="btn-item"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        <app-button
          buttonType="primary"
          styleType="contained"
          sizeType="small"
          [text]="
            translationService.getCurrentLanguage()['project'] || 'Projetar'
          "
          (click)="onBtnProjectClick()"
          [disabled]="!wkidItemOutSelected"
          width="12.1rem"
        ></app-button>
      </div>
    </div>
  </section>
</app-scroll-view>

<div class="actions-bottom">
  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      [text]="translationService.getCurrentLanguage()['get'] || 'Obter'"
      (click)="onBtnGetMapPointClick()"
      width="100%"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      [text]="translationService.getCurrentLanguage()['zoom'] || 'Zoom'"
      (click)="onBtnZoomToClick()"
      width="100%"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="normal"
      styleType="contained"
      [text]="translationService.getCurrentLanguage()['clear'] || 'Limpar'"
      (click)="onBtnClearClick()"
      width="100%"
    ></app-button>
  </div>
</div>
